import { InjectionToken } from '@angular/core';
import { Dictionary } from '@softline/core';

export interface LoginLink {
  name: string;
  route: string | string[];
}

export interface LoginConfig {
  scan?: boolean;
}

export const SOFTLINE_CONFIG_LOGIN_LINKS = new InjectionToken<LoginLink[]>(
  'SOFTLINE_CONFIG_LOGIN_LINKS'
);
export const SOFTLINE_CONST_SETTINGS_GROUP_LOGIN = 'login';

export const SOFTLINE_CONFIG_LOGIN = new InjectionToken<LoginConfig>(
  'SOFTLINE_CONFIG_LOGIN'
);

export type BeforeHookFn = () => boolean;
export type AfterHookFn = () => void;

export interface AuthenticationHooks {
  logout?: {
    before?: BeforeHookFn[];
    after?: AfterHookFn[];
  };
  login?: {
    before?: BeforeHookFn[];
    after?: AfterHookFn[];
  };
}

export const SOFTLINE_CONFIG_AUTHENTICATION_HOOKS = new InjectionToken<
  AuthenticationHooks[]
>('SOFTLINE_CONFIG_AUTHENTICATION_HOOKS');

export type ClaimProviderFn = () => Promise<Dictionary<any>>;

export const SOFTLINE_CONFIG_LOGIN_CLAIM_PROVIDER = new InjectionToken<ClaimProviderFn[]>(
  'SOFTLINE_CONFIG_LOGIN_CLAIM_PROVIDER'
);
